import React from 'react';
import {
  buildWatchUrl,
  isTruthy,
  nmpIframeAllow,
} from '../NmpVideo/nmpWatchUrl';
import './HeroNmpVideo.scss';

export default function HeroNmpVideo({
  className = '',
  fit = 'cover',
  nmpAssetId,
  nmpAutoplay,
  nmpHideControls,
  nmpMuted,
  nmpLoop,
  nmpTheme,
}) {
  const src = buildWatchUrl({
    nmpAssetId,
    nmpAutoplay,
    nmpHideControls,
    nmpMuted,
    nmpLoop,
    nmpTheme,
  });

  if (!src) return null;

  const allow = nmpIframeAllow(src, false);

  const fitClass =
    fit === 'contain' ? 'hero-nmp-video--fit-contain' : 'hero-nmp-video--fit-cover';

  return (
    <div className={`hero-nmp-video ${fitClass} ${className}`.trim()}>
      <iframe
        src={src}
        title="Hero video"
        {...(allow ? { allow } : {})}
      />
    </div>
  );
}

export function heroUsesNmpVideo(heroVideoSource, nmpAssetId) {
  return heroVideoSource === 'nmp' && String(nmpAssetId || '').trim();
}

export function heroNmpAutoplayOn(nmpAutoplay) {
  return isTruthy(nmpAutoplay);
}
